import { render, staticRenderFns } from "./schedules.page.vue?vue&type=template&id=445e3578&scoped=true&"
import script from "./schedules.page.vue?vue&type=script&lang=js&"
export * from "./schedules.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e3578",
  null
  
)

export default component.exports